import styled from 'styled-components';
import { DefaultText } from '../../../styles/global/css/GlobalText';
import { PrimaryColor, BorderColor2, DarkGreySidely2, SidelyBlack, SurfaceColor } from '../../../styles/global/css/Utils';

const Container = styled.div`
    padding-left: 20px;
    width: 100%;
`;

const Header = styled.div``;

const Row = styled.div`
    margin-top: 10px;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-content: center;
    align-items: center;
`;

const Label = styled.p`
    ${DefaultText}
    font-size: 12px;
    line-height: 18px;
    font-weight: 400;
    color: ${SidelyBlack};
    margin-left: 3%;
`;

interface CheckboxProps {
	isActive: boolean,
	size?: string,
	disabled?: boolean
}

const Checkbox = styled.div<CheckboxProps>`
    width: ${p => p.size ?? '14px'};
    height: ${p => p.size ?? '14px'};
    border-radius: 4px;
    border: 1px solid ${p => p.isActive && !p.disabled ? PrimaryColor : BorderColor2};
    background: ${SurfaceColor};
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: center;
    font-family: monospace;
    cursor: ${p => p.disabled ? 'not-allowed' : 'pointer'};
    font-size: ${p => `calc(${p.size ?? '14px'} + 2px)`};

    ${p => p.isActive
		? `
    &:after {
        content: '✔';
        color: ${p.disabled ? BorderColor2 : PrimaryColor};
    }
    `
		: ''}

`;

interface RadioProps {
	isActive: boolean
	inactiveColor?: string,
	size?: string
}

const Radio = styled.div<RadioProps>`
    width: ${p => p.size ?? '14px'};
    height: ${p => p.size ?? '14px'};
    border: 1px solid ${p => p.isActive ? PrimaryColor : p.inactiveColor ?? DarkGreySidely2};
    background-color: ${SurfaceColor};
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    align-content: center;
    justify-content: center;
    align-items: center;

    ${p => p.isActive
		? `
    &:after {
        content: ' ';
        background-color: ${PrimaryColor};
        width: 9px;
        height: 9px;
        display: block;
        border-radius: 50%;
    }
    `
		: ''
}
`;


export {
	Container,
	Header,
	Row,
	Label,
	Checkbox,
	Radio,
};
